module.exports = __webpack_public_path__ + "img/bn1.9283c4c2.png";